import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { AppConfig } from '../../../app.settings';
import { ServerDataBackup } from '../../models/view-models/backups-models/server-data-backup.view-model';
import { ServerDataBackupingInProgress } from '../../models/view-models/backups-models/server-data-backuping-in-progress.view-model';

@Injectable()
export class ServerDataBackupService {

  public isPendingFileDownload$: BehaviorSubject<ServerDataBackupingInProgress> = new BehaviorSubject(new ServerDataBackupingInProgress());
  private endpoint: string;

  constructor(private http: HttpClient, private config: AppConfig) {
    this.endpoint = `${this.config.getConfig('api')}Admin/backups`;
  }

  importBackup(file: File, password: string): Observable<any> {

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', '*/*');

    const params = new HttpParams()
      .set('password', password);

    const req: HttpRequest<any> = new HttpRequest('POST', `${this.endpoint}/import-backup`, formData, {
      headers,
      params,
      reportProgress: true
    });

    return this.http.request(req);
  }

  getBackupFile(serverDataBackup: ServerDataBackup): Observable<any> {
    const params = new HttpParams()
      .set('password', serverDataBackup.password)
      .set('isMediaIncluded', JSON.stringify(serverDataBackup.isMediaIncluded));

    const req: HttpRequest<any> = new HttpRequest('GET', this.endpoint, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params,
      observe: 'response',
      responseType: 'blob' as 'json',
      reportProgress: true
    });

    return this.http.request(req);
  }

  deleteExportFileByFileName(): Observable<void> {
    return this.http.delete<void>(this.endpoint);
  }
}
